import styled from 'vue-styled-components';

import theme from '@/config/theme';

export default styled('span')`
  align-items: center;
  background-color: ${theme.colors.supportAlert};
  border-radius: ${theme.border.radius.circle};
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
  color: ${theme.colors.black};
  display: inline-flex;
  font-size: 12px;
  font-weight: ${theme.font.bold};
  height: 21px;
  justify-content: center;
  width: 21px;
`;
